
























import { Component, Vue, Prop } from 'vue-property-decorator';
import GlobalMixins from '../mixins';

@Component
export default class OptionsHeader extends GlobalMixins {
	@Prop({ required: true }) title!: string
	@Prop({ required: true }) subtitle!: string
	@Prop({ required: true }) ariaSubtitle!: string
	@Prop({ required: false }) buttonType?: 'next' | 'results'
	@Prop({ required: false }) buttonTexts?: { next?: string, results?: string, skip?: string }
	@Prop({ required: false }) buttonDisabled?: boolean
	@Prop({ required: false }) hideButtons?: boolean
}
